import React from "react";
import { Card, Button } from "react-bootstrap";
import CustomCard from "../../../ui/CustomCard/CustomCard";
import "./GroupInvitationCard.css";
import { BsFillPeopleFill } from "react-icons/bs";

function GroupInvitationCard(props) {
  const group_id = props.invitation?.user_group_id
    ? props.invitation.user_group_id
    : "NA";
  const name = props.invitation?.owner.fullname
    ? props.invitation.owner.fullname
    : "Unknown";
  const group_name = props.invitation?.title
    ? props.invitation.title
    : "Unknown";

  const handleAcceptBtnClick = (invitation) => {
    props.getGroupInvitationData(invitation, "accept");
  };
  const handleRejectBtnClick = (invitation) => {
    props.getGroupInvitationData(invitation, "reject");
  };

  return (
    <>
      <CustomCard
        className={`group_invitation_card main_card shadow1 border-0 mb2`}
      >
        <Card.Header className="group_invitation_card_header ">
          <div className="media">
            <div className="media_icon_wrap d-flex align-items-center justify-content-center">
              <BsFillPeopleFill />
            </div>

            <div className={`media_body ms-3`}>
              <Card.Title className="card_title">Request by {name}</Card.Title>
              <Card.Subtitle className="card_subtitle">
                {`You have been invited to join a group (${group_name})`}
              </Card.Subtitle>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="group_invitation_card_body">
          <div className="btn_wrap">
            <Button
              type="button"
              className="btn_theme btn_small btn_secondary btn_rounded"
              onClick={() => {
                handleAcceptBtnClick(props.invitation);
              }}
            >
              Accept
            </Button>
            <Button
              type="button"
              className="btn_theme btn_small btn_danger btn_rounded"
              onClick={() => {
                handleRejectBtnClick(props.invitation);
              }}
            >
              Ignore
            </Button>
          </div>
        </Card.Body>
      </CustomCard>
    </>
  );
}

export default GroupInvitationCard;
